import './gmt.scss';

import '@/utils/common.js';
import ScrollAnim from '@/utils/scroll-anim.js';
import initLeaderIntroduction from '@/components/leader-introduction/leader-introduction.js';

new ScrollAnim();
initLeaderIntroduction();

$(function () {
    let $timeline = $('.time-line').data({ animStatus: false });
    function handlePageScroll() {
        if (
            $(document).scrollTop() >=
                $timeline.offset().top +
                    $timeline.outerHeight() / 2 -
                    $(window).outerHeight() &&
            !$timeline.data('animStatus')
        ) {
            $timeline.data({ animStatus: true }).addClass('into-page');
        }
    }
    handlePageScroll();
    $(document).scroll(handlePageScroll);
});
